var map = {
	"./1-design.jpg": 34890,
	"./Chinavisap2024-0 copy.JPG": 36217,
	"./Chinavisap2024-0.JPG": 28152,
	"./Chinavisap2024-1.JPG": 27989,
	"./Chinavisap2024-2.JPG": 18698,
	"./Chinavisap2024-3.JPG": 39911,
	"./VISAP23-1.jpeg": 19115,
	"./VISAP23-2.jpeg": 29534,
	"./VISAP23-3.jpg": 94396,
	"./VISAP23-4.jpg": 95943,
	"./VISAP23-5.jpeg": 43303,
	"./VISAP23-6.jpeg": 12746,
	"./VISAP23-7.jpeg": 20145,
	"./VISAP23-8.jpeg": 22796,
	"./VISAP23-9.jpeg": 85075,
	"./info+2023.jpg": 44716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8841;